import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authorizedGuard } from '../../shared/guards/authorized.guard';
import { ServiceComponent } from './service.component';

const routes: Routes = [
  {
    path: '',   
    component: ServiceComponent,
    canActivate: [authorizedGuard],      
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceRoutingModule { }
